"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _useFirstMount = _interopRequireDefault(require("./useFirstMount"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable react-hooks/exhaustive-deps */


var useUpdateEffect = function useUpdateEffect(effect) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isFirstMount = (0, _useFirstMount.default)();
  (0, _react.useEffect)(function () {
    if (!isFirstMount) {
      return effect();
    }

    return undefined;
  }, deps);
};

var _default = useUpdateEffect;
exports.default = _default;